import { AxiosError } from 'axios';
import { put, call, takeLatest, select } from 'redux-saga/effects';
import { API } from '../api/base';
import {
  types,
  GetOrderDetailsAsyncRequest,
  GetOrdersAsyncRequest,
  GetOrderDetailsResponse,
  GetOrdersResponse
} from './types';
import { selectors as ticketingSelectors } from 'services/ticketing';
import { getErrorMessage, getErrorMessageCode } from 'services/api/normalizer';
import i18n from 'services/translation/i18n';

export function* getOrderDetailsAsync({ payload }: GetOrderDetailsAsyncRequest) {
  yield put({ type: types.GET_ORDER_DETAILS.PENDING, payload: true });

  try {
    const session: string | null = yield select(ticketingSelectors.selectSession);
    const orderApi = new API(`ticketing/order?session=${session}`);
    const response: GetOrderDetailsResponse = yield call(orderApi.create, payload);
    yield put({ type: types.GET_ORDER_DETAILS.SUCCESS, payload: response });
  } catch (err) {
    let message = '';
    const errCode = getErrorMessageCode(err as AxiosError);
    if (errCode) {
      if (errCode === 404) {
        message = i18n.t('sagaError.noOrderFound');
      } else if (errCode === 401) {
        message = i18n.t('sagaError.lookupError');
      }
    } else {
      message = getErrorMessage(err as AxiosError) || i18n.t('sagaError.lookupError');
    }

    yield put({ type: types.GET_ORDER_DETAILS.ERROR, payload: message });
  } finally {
    yield put({ type: types.GET_ORDER_DETAILS.PENDING, payload: false });
  }
}

export function* getOrdersAsync({ payload }: GetOrdersAsyncRequest) {
  yield put({ type: types.GET_WILL_CALL_ORDERS.PENDING, payload: true });

  try {
    const session: string | null = yield select(ticketingSelectors.selectSession);

    const orderApi = new API(`ticketing/orders`);
    const response: GetOrdersResponse = yield call(orderApi.getAll, { session, ...payload });
    if (response && response.orderSummaries && response.orderSummaries.length) {
      yield put({ type: types.GET_WILL_CALL_ORDERS.SUCCESS, payload: response });
    } else if (response && response.orders && response.orders.length) {
      yield put({ type: types.GET_ORDER_DETAILS.SUCCESS, payload: response });
    } else {
      yield put({ type: types.GET_WILL_CALL_ORDERS.ERROR, payload: i18n.t('sagaError.noOrderFound') });
    }
  } catch (err) {
    yield put({ type: types.GET_WILL_CALL_ORDERS.ERROR, payload: i18n.t('sagaError.noOrderFound') });
  } finally {
    yield put({ type: types.GET_WILL_CALL_ORDERS.PENDING, payload: false });
  }
}

export const sagas = [
  takeLatest(types.GET_ORDER_DETAILS.REQUEST, getOrderDetailsAsync),
  takeLatest(types.GET_WILL_CALL_ORDERS.REQUEST, getOrdersAsync)
];
